/** Messages échangés entre onglets pour partager la session. */
export enum AuthTabSyncMessageType {
  /** Un onglet sans jeton demande la session des onglets connectés. */
  SessionRequest = 'session-request',
  /** Réponse d'un onglet connecté, adressée à une demande précise. */
  SessionReply = 'session-reply',
  /** Déconnexion explicite : tous les onglets ferment leur session. */
  Logout = 'logout',
}

export interface SessionRequestMessage {
  type: AuthTabSyncMessageType.SessionRequest;
  requestId: string;
}

export interface SessionReplyMessage {
  type: AuthTabSyncMessageType.SessionReply;
  requestId: string;
  token: string;
}

export interface LogoutMessage {
  type: AuthTabSyncMessageType.Logout;
}

export type AuthTabSyncMessage =
  | SessionRequestMessage
  | SessionReplyMessage
  | LogoutMessage;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/**
 * Valide un message reçu d'un autre onglet : tout ce qui n'a pas exactement la
 * forme attendue est ignoré.
 */
export function isAuthTabSyncMessage(
  value: unknown
): value is AuthTabSyncMessage {
  if (!isRecord(value)) {
    return false;
  }
  switch (value['type']) {
    case AuthTabSyncMessageType.SessionRequest:
      return typeof value['requestId'] === 'string';
    case AuthTabSyncMessageType.SessionReply:
      return (
        typeof value['requestId'] === 'string' &&
        typeof value['token'] === 'string'
      );
    case AuthTabSyncMessageType.Logout:
      return true;
    default:
      return false;
  }
}
